import { Image } from 'react-bootstrap';
import { readCartMessage } from './cartMessages';

export default function CartHeading({ messages }) {
  return (
    <h1 className="mb-4 d-flex align-items-center">
      <Image
        src="/icons/cart.png"
        alt={readCartMessage(messages, 'cart', 'brandMarkAlt', 'cart')}
        width="28"
        height="28"
        className="cart-icon me-2"
      />
      {readCartMessage(messages, 'cart', 'header', 'Cart')}
    </h1>
  );
}
